<template>
    <Head title="Liste des messages application" />

    <AppLayout>
        <div x-data="handleSelect">
            <Datatables>
                <template #title>
                    Messages application
                    <span class="font-medium">({{ messages.total }})</span>
                </template>

                <template #headerButtons>
                    <Link v-if="$page.props.acl.isAdmin" :href="route('app-messages.create')"
                        class="rounded-md py-1 px-2 bg-white text-sky hover:bg-sky-400 hover:text-white"
                        title="Ajouter un message"
                    >
                        <i class="fad fa-plus-circle"></i>
                    </Link>
                </template>
                <template #tableHeader>
                    <th>#</th>
                    <th>Image</th>
                    <th>Titre</th>
                    <th>Message</th>
                    <th>Type</th>
                    <th>Priorité</th>
                    <th>Statut</th>
                    <!-- <th>&nbsp;</th> -->
                </template>

                <template #tableBody>
                    <tr v-for="(message, index) in messages.data" :key="message.id">
                        <td>{{ index + 1 }}</td>
                        <td class="flex justify-center">
                            <img v-if="message.cover_url" :src="message.cover_url" class="w-12 h-12 rounded object-cover" />
                            <img v-else :src="'/assets/app/'+message.type+'.png'" class="w-12 h-12 rounded object-cover" />
                        </td>
                        <td>{{ message.title }}</td>
                        <td class="text-xs text-left">
                            {{ ((message.message ?? '').substring(0, 50)) }}{{ (message.message ?? '').length > 50 ? '...' : '' }}
                        </td>
                        <td><StatusBadge :label="message.type_text" :color="message.type_color" /></td>
                        <td class="text-center">{{ message.priority }}</td>
                        <td>
                            <span :class="message.is_active ? 'text-greendack-600' : 'text-red-600'">
                                {{ message.is_active ? 'Actif' : 'Inactif' }}
                            </span>
                        </td>
                        <!-- <td>
                            <div class="flex justify-end items-center space-x-3">
                                <i @click="destroyMessage(message)" title="Supprimer"
                                    class="fad fa-trash text-red-500 hover:text-red-600 cursor-pointer"
                                ></i>
                            </div>
                        </td> -->
                    </tr>
                </template>
            </Datatables>
        </div>
    </AppLayout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout.vue'
    import Datatables from '@/Components/Datatables'
    import StatusBadge from '@/Components/StatusBadge'
    import { Head, Link } from '@inertiajs/inertia-vue3'

    export default {
        components:{
            Link,
            Head,
            AppLayout,
            Datatables,
            StatusBadge
        },

        props:{
            messages: Object
        },

        methods:{
            destroyMessage(message){
                this.$swal.queue([{
                    title:"Message",
                    text:"Etes vous sûr de vouloir supprimer le message ?",
                    icon:"warning",
                    showCancelButton: true,
                    confirmButtonColor: 'rgb(241, 162, 0)',
                    cancelButtonColor: '#bd081c',
                    confirmButtonText:"Supprimer",
                    showLoaderOnConfirm:true,
                    preConfirm: () => {
                        return this.$inertia.delete(route('app-messages.destroy', message), {
                            preserveScroll:true,
                            onSuccess: () => {
                                this.$swal.fire(
                                    'Message',
                                    'Message supprimé avec succès.',
                                    'success'
                                )
                            },
                            onError: (error) => {
                                this.$swal.fire({
                                    icon: 'error',
                                    title: error.message
                                })
                            }
                        })
                    }
                }])
            }
        }
    }
</script>